import { Field } from '@headlessui/react';
import { type FC, type ReactNode } from 'react';
import { cx } from '@/utils/cx';
import { Description } from './description';
import { Label } from './label';
import { Switch, SwitchProps } from '../ui/switch';

export type SwitchFieldProps = SwitchProps & {
  description?: ReactNode;
};

export const SwitchField: FC<SwitchFieldProps> = ({
  className,
  description,
  enabled,
  label,
  onChange,
  ...props
}) => (
  <Field
    className={cx(
      'flex flex-row items-center justify-between gap-4',
      className,
    )}
  >
    <div className="flex flex-col">
      <Label>{label}</Label>
      {description && <Description>{description}</Description>}
    </div>
    <Switch enabled={enabled} label={label} onChange={onChange} {...props} />
  </Field>
);
